export default function About() {
  return (
    <section id="about" className="relative py-24 bg-gradient-to-b from-black via-[#0a0a0a] to-black overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, #D4AF37 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            {/* Meet the Owners Label */}
            <div className="mb-4 text-center">
              <span className="inline-block px-6 py-2.5 bg-[#D4AF37] text-black font-['Orbitron'] font-bold text-sm tracking-widest rounded-lg shadow-lg shadow-[#D4AF37]/20">
                MEET THE OWNERS
              </span>
            </div>

            <div className="relative rounded-2xl overflow-hidden border border-[#D4AF37]/20 bg-black/30 h-[500px]">
              <img
                src="https://static.readdy.ai/image/74809ee30fca19c1acffe2fc12cb4256/9f5a4d7c595bc21e40cc16f1bf733cbf.jpeg"
                alt="A&H Junk Removal - Father and Son Team"
                className="w-full h-full object-cover object-center brightness-105 contrast-110 saturate-110"
              />
              {/* Subtle overlay for better integration */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-black/20"></div>
            </div>

            {/* Decorative Line */}
            <div className="absolute top-1/2 -left-12 w-8 h-px bg-[#D4AF37] hidden lg:block"></div>
          </div>

          {/* Content Side */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#3D3225] rounded-full mb-6">
              <i className="ri-heart-line text-[#D4AF37]"></i>
              <span className="text-[#C4A574] text-sm font-medium tracking-wider">OUR STORY</span>
            </div>

            <h3 className="font-['Orbitron'] text-4xl sm:text-5xl font-bold text-white mb-6 leading-tight">
              Built on <span className="text-[#D4AF37]">Family</span> & <span className="text-[#D4AF37]">Loyalty</span>
            </h3>

            <div className="space-y-6 text-gray-300 text-lg leading-relaxed">
              <p>
                A&H Junk Removal isn&apos;t just a business—it&apos;s a family legacy. As a father and son team, 
                we bring the same values we live by at home to every job we do: <strong className="text-white">honesty, 
                hard work, and treating every customer like family.</strong>
              </p>
              <p>
                When you call us, you&apos;re not getting a faceless corporation. You&apos;re getting two generations 
                of dedication, working side by side to clear out your space and make your life easier. 
                We take pride in our work because our name is on the truck.
              </p>
              <p>
                <span className="text-[#D4AF37]">Family means everything to us.</span> That&apos;s why we treat your 
                home with the same respect we&apos;d give our own. No shortcuts, no excuses—just reliable, 
                professional service you can count on.
              </p>
            </div>

            {/* Values */}
            <div className="grid grid-cols-3 gap-4 mt-10">
              <div className="text-center p-4 bg-black/50 rounded-xl border border-gray-800">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 bg-[#D4AF37]/10 rounded-lg">
                  <i className="ri-shield-check-line text-2xl text-[#D4AF37]"></i>
                </div>
                <p className="text-white font-semibold">Trust</p>
              </div>
              <div className="text-center p-4 bg-black/50 rounded-xl border border-gray-800">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 bg-[#D4AF37]/10 rounded-lg">
                  <i className="ri-hand-heart-line text-2xl text-[#D4AF37]"></i>
                </div>
                <p className="text-white font-semibold">Loyalty</p>
              </div>
              <div className="text-center p-4 bg-black/50 rounded-xl border border-gray-800">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 bg-[#D4AF37]/10 rounded-lg">
                  <i className="ri-team-line text-2xl text-[#D4AF37]"></i>
                </div>
                <p className="text-white font-semibold">Family</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
